export type NetworkReachabilityState = {
  isConnected: boolean | null;
  isInternetReachable: boolean | null;
};

/**
 * Treat the device as offline only when NetInfo reports no connection
 * or no internet. Unknown/null values stay online so the app does not
 * flash this screen during the first connectivity check.
 */
export function isOfflineFromNetInfo(state: NetworkReachabilityState): boolean {
  if (state.isConnected === false) {
    return true;
  }
  if (state.isInternetReachable === false) {
    return true;
  }
  return false;
}
